import IComponent from "components/commons/IComponent";
import OpacitySlider from "components/LayerSetting/OpacitySlider";
import Button from "@material-ui/core/Button";
import "./ItemCard.scoped.css";

const LAYER_TYPE_OPACITY_SUPPORT = {
  "building-scene": 1,
  // "point-cloud": 1,
  scene: 1,
  feature: 1,
  bim: 1,
};

const DOWNLOAD_SUPPORT = {
  "point-cloud": 1,
  voxel: 1,
};

class ShowOperationBox extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      showOperationBox: true,
    };
  }
  componentWillUnmount() {}
  onLeaveOperationContainer() {
    this.setState({
      showOperationBox: false,
    });
  }

  onDownloadClick() {
    if (this.props.layerItem.metaData?.downloadUrl) {
      window.open(this.props.layerItem.metaData.downloadUrl, "_blank");
    } else {
      this.props.showDialog({
        isOpen: true,
        title: "Data Download",
        content: "This item has no download information yet.",
        onDialogOk: () => {},
      });
    }
  }
  onInfoClick() {
    //TODO: info from metaData
    console.log(this.props.layerItem);
    this.props.showDialog({
      isOpen: true,
      title: "Additional Information",
      content: `${this.props.layerItem.metaData?.info ||
        "No additional information is provided for this item yet."}`,
      onDialogOk: () => {},
    });
  }
  render() {
    let { layerItem } = this.props;
    // if (!this.state.showOperationBox) return;

    // true
    return (
      <div
        onMouseLeave={this.onLeaveOperationContainer.bind(this)}
        className="layer3DItemOperationContainer"
      >
        <div className="layer3DOpacitySlider">
          {layerItem.type in LAYER_TYPE_OPACITY_SUPPORT &&
            "layer" in layerItem &&
            !!layerItem?.layer?.visible && (
              <OpacitySlider
                darkMode={true}
                layer={
                  layerItem.type in LAYER_TYPE_OPACITY_SUPPORT
                    ? layerItem.layer
                    : undefined
                }
              />
            )}
        </div>
        <div className="layer3DInfoAndDownload">
          <Button onClick={this.onInfoClick.bind(this)}>
            <span
              className="icn_black_24dp"
              style={{ filter: "brightness(300%) invert(1)" }}
            />
            <span>&nbsp;</span>
            <span>Info</span>
          </Button>
          {layerItem.type in DOWNLOAD_SUPPORT && (
            <Button onClick={this.onDownloadClick.bind(this)}>
              <span
                className="icn_download"
                style={{ filter: "brightness(300%) invert(1)" }}
              />
              <span>&nbsp;</span>
              <span>Download</span>
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default ShowOperationBox;
